import { action, observable } from 'mobx';
import {
  MatrixProtectLogStepType,
  MatrixProtectLogType,
} from 'enums/AllStateInsurance.enum';
import ApiRoutes from 'routes/api/ApiRoutes';
import Store from './Store';
import { ModelItem } from '../models/ModelItem';
import { ApplicationInsurance } from '../models/entities/ApplicationInsuranceModel';

export class ApplicationInsuranceStore extends Store<ApplicationInsurance> {
  constructor() {
    super();
    ApplicationInsurance._store = this;
  }

  @observable applicationInsuranceItem = new ModelItem<ApplicationInsurance>(
    ApplicationInsurance,
  );

  @action
  async matrixProtectLogCreate(
    user_id: string,
    application_id: number,
    applicant_id: number,
    step: MatrixProtectLogStepType,
  ): Promise<void> {
    const response = await this.apiService.post(
      ApiRoutes.matrixProtectLog.create,
      {
        user_id,
        step,
        type: MatrixProtectLogType.IN_APP_CREATION,
        application_id,
        applicant_id,
      },
    );
    if (response) {
      return response;
    }
    throw new Error('Failed to create Matrix Protect Log');
  }

  @action
  clearStore(): void {
    this.applicationInsuranceItem = new ModelItem<ApplicationInsurance>(
      ApplicationInsurance,
    );
  }
}
